class AudienceToggle {
  constructor() {
    this.storageKey = 'kabodeAudience';
    this.defaultAudience = 'kids';
    this.validAudiences = ['kids', 'adults'];

    this.init();
  }

  init() {
    this.audience = this.getSavedAudience();
    document.documentElement.setAttribute('data-audience', this.audience);

    this.bindToggleButtons();
    this.applyAudience(this.audience, false);

    document.addEventListener('shopify:section:load', () => {
      this.applyAudience(this.getSavedAudience(), false);
      this.bindToggleButtons();
    });

    document.addEventListener('shopify:section:reorder', () => {
      this.applyAudience(this.getSavedAudience(), false);
    });
  }

  getSavedAudience() {
    try {
      const saved = localStorage.getItem(this.storageKey);
      if (this.validAudiences.includes(saved)) return saved;
    } catch (e) {}
    return this.defaultAudience;
  }

  saveAudience(audience) {
    try {
      localStorage.setItem(this.storageKey, audience);
    } catch (e) {}
  }

  bindToggleButtons() {
    const buttons = document.querySelectorAll('[data-audience-toggle-button]');
    buttons.forEach((button) => {
      if (button.dataset.audienceBound === 'true') return;

      button.addEventListener('click', () => {
        const audience = button.getAttribute('data-audience-toggle-button');
        if (!this.validAudiences.includes(audience)) return;
        this.applyAudience(audience, true);
      });

      button.dataset.audienceBound = 'true';
    });
  }

  applyAudience(audience, persist = true) {
    this.audience = audience;
    document.documentElement.setAttribute('data-audience', audience);

    if (persist) this.saveAudience(audience);

    this.updateToggleUI(audience);
    this.updateAudienceSections(audience);
    this.updateAudienceMenus(audience);
  }

  updateToggleUI(audience) {
    const buttonGroups = document.querySelectorAll('[data-audience-toggle]');
    buttonGroups.forEach((group) => {
      const buttons = group.querySelectorAll('[data-audience-toggle-button]');
      buttons.forEach((button) => {
        const isActive = button.getAttribute('data-audience-toggle-button') === audience;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      group.setAttribute('data-current-audience', audience);
    });
  }

  updateAudienceSections(audience) {
    const sections = document.querySelectorAll('[data-audience-section]');
    sections.forEach((section) => {
      const sectionAudience = section.getAttribute('data-audience-section');
      const shouldShow =
        sectionAudience === 'both' || sectionAudience === audience;

      section.hidden = !shouldShow;
      section.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }

  updateAudienceMenus(audience) {
    const menus = document.querySelectorAll('[data-audience-menu]');
    menus.forEach((menu) => {
      const menuAudience = menu.getAttribute('data-audience-menu');
      const shouldShow = menuAudience === audience;

      menu.hidden = !shouldShow;
      menu.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }
}

if (!window.KabodeAudienceToggle) {
  window.KabodeAudienceToggle = new AudienceToggle();
}